module.exports = __webpack_public_path__ + "static/toolbox-Hover-4b57d0d014be08f78e5be7686150e9e4.jpg";